module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.5616/img/provider-ctas-blob-2x.png"